import { Container } from "react-bootstrap";
import ProjectList from "./ProjectList";
import Search from "./Search";
import React, { useState, useEffect } from "react";
export default function CommunitySolar() {
  const [projects, setProjects] = useState([]);
  const [usStates, setUsStates] = useState(["ALL"]);
  const [providers, setProviders] = useState(["ALL"]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL_PROD}/api/states`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((respn) => respn.json())
      .then((resp) => {
        resp.map((item) => {
          if (!usStates.includes(item.state)) {
            setUsStates((usStates) => [...usStates, item.state]);
          }
        });
      })
      .catch((error) => console.log(error));

    fetch(`${process.env.REACT_APP_API_URL_PROD}/api/providers`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((respn) => respn.json())
      .then((resp) => {
        resp.map((item) => {
          setProviders((providers) => [...providers, item.provider]);
        });
      });
  }, []);

  const searchProjects = (query) => {
    fetch(
      `${process.env.REACT_APP_API_URL_PROD}/api/solar-projects?` +
        new URLSearchParams(query),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((respn) => respn.json())
      .then((resp) => setProjects(resp))
      .catch((error) => console.log(error));
  };
  return (
    <>
      <header>
        <h1
          className="h1-black"
          style={{ textAlign: "center", marginTop: "8%", marginBottom: "3%" }}
        >
          Solar Without the Rooftop
        </h1>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingLeft: "10%",
            paddingRight: "10%",
          }}
        >
          {" "}
          <p style={{ fontSize: "small", textAlign: "center" }}>
            Get <b>10-25% off</b> your electricity bill at no cost to sign up.
            Enjoy bill savings powered by distributed, clean energy.
          </p>
        </div>

        <Container>
          <Search
            searchButtonClicked={searchProjects}
            usStates={usStates}
            providers={providers}
          ></Search>

          <ProjectList projects={projects}></ProjectList>
        </Container>
      </header>
    </>
  );
}
